import { useNavigate } from 'react-router-dom';
const C = {bg:'#0A0E1A',card:'#0D1526',accent:'#00D4AA',gold:'#F59E0B',border:'#1e2d45',text:'#E8EDF5',muted:'#6b7fa3',navy:'#003366'};
export default function ContactPage() {
  const navigate = useNavigate();
  return (
    <div style={{fontFamily:'sans-serif',background:C.bg,color:C.text,position:'fixed',inset:0,overflowY:'auto'}}>
      <div style={{position:'sticky',top:0,zIndex:100,background:C.bg,borderBottom:`1px solid ${C.border}`,padding:'14px 20px',display:'flex',alignItems:'center',gap:12}}>
        <button onClick={()=>navigate('/')} style={{background:'none',border:'none',color:C.accent,fontSize:24,cursor:'pointer'}}>&#8249;</button>
        <div>
          <span style={{fontSize:20,fontWeight:700,color:C.accent}}>PAY</span>
          <span style={{fontSize:20,fontWeight:700,color:C.text,position:'relative',left:-5}}>CHAT</span>
        </div>
      </div>
      <div style={{padding:'40px 24px'}}>
        <div style={{fontSize:28,fontWeight:700,marginBottom:8}}>Nous contacter</div>
        <div style={{fontSize:13,color:C.muted,marginBottom:32}}>ZENVOI SARL — Douala, Cameroun</div>
        {[
          {icon:'📞',label:'Téléphone',value:'+237 697 008 362',href:'tel:+237697008362'},
          {icon:'📧',label:'Email général',value:'GilbertOdzo@zenvoi.co',href:'mailto:GilbertOdzo@zenvoi.co'},
          {icon:'📧',label:'Investisseurs',value:'invest@zenvoi.co',href:'mailto:GilbertOdzo@zenvoi.co?subject=Investissement PayChat'},
          {icon:'📧',label:'Partenariats',value:'partners@zenvoi.co',href:'mailto:GilbertOdzo@zenvoi.co?subject=Partenariat PayChat'},
          {icon:'🌐',label:'Application',value:'https://zenvoi.app',href:'https://zenvoi.app'},
          {icon:'📍',label:'Adresse',value:'BP 12619, Douala, Cameroun',href:null},
        ].map((c,i)=>(
          <div key={i} style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:14,padding:16,marginBottom:12,display:'flex',gap:14,alignItems:'center'}}>
            <div style={{fontSize:24,flexShrink:0}}>{c.icon}</div>
            <div style={{flex:1}}>
              <div style={{fontSize:11,color:C.muted,marginBottom:2}}>{c.label}</div>
              {c.href
                ? <a href={c.href} style={{fontSize:14,color:C.accent,textDecoration:'none',fontWeight:600}}>{c.value}</a>
                : <div style={{fontSize:14,color:C.text}}>{c.value}</div>
              }
            </div>
          </div>
        ))}
        <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:14,padding:16,marginTop:8}}>
          <div style={{fontSize:14,fontWeight:700,marginBottom:12}}>Suivez-nous</div>
          {[['Facebook','🇫🇷','Page PayChat by ZENVOI','https://facebook.com'],['Instagram','📸','@paychat_zenvoi','https://instagram.com'],['LinkedIn','💼','ZENVOI SARL','https://linkedin.com']].map(([n,ic,h,url],i)=>(
            <div key={i} style={{display:'flex',alignItems:'center',gap:12,padding:'10px 0',borderBottom:i<2?`1px solid ${C.border}`:'none'}}>
              <div style={{fontSize:20}}>{ic}</div>
              <div style={{flex:1}}>
                <div style={{fontSize:13,fontWeight:600}}>{n}</div>
                <div style={{fontSize:12,color:C.muted}}>{h}</div>
              </div>
              <a href={url} style={{fontSize:12,color:C.accent,textDecoration:'none'}}>Suivre</a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
